export let log = {
    info: (...args) => {},
    debug: (...args) => {},
    error: (...args) => {},
    warn: (...args) => {},
    log: (...args) => {},
};

export const init = (externalLogger) => {
    if (!externalLogger) {
        throw new Error('iqos-mw error: log is required');
    }

    log = externalLogger;
};
